import { Alert } from 'antd-v4'
import { observer } from 'mobx-react'
import React from 'react'
import { COLORS } from '../../../../../constants/Colors'
import { CreateProduct } from '../ProductStore'

interface Props {
  product: CreateProduct
}

@observer
export class VariantStatusSection extends React.Component<Props> {
  getMessage = () => {
    const childProducts = this.props.product.childProducts
    const activeProducts = []
    const inactiveProducts = []

    for (let i = 0; i < childProducts.length; i++) {
      childProducts[i].isActive
        ? activeProducts.push(childProducts[i])
        : inactiveProducts.push(childProducts[i])
    }

    return (
      <>
        <div style={{ color: COLORS.blue800 }}>Active/Inactive:</div>
        <div style={{ display: 'flex' }}>
          <span
            style={{
              height: '12px',
              width: '12px',
              backgroundColor: COLORS.green600,
              borderRadius: '50%',
              alignSelf: 'center',
              marginRight: '20px',
            }}
          ></span>
          <div style={{ color: COLORS.bluegrey700 }}>Active ({activeProducts.length})</div>
        </div>
        <div style={{ display: 'flex' }}>
          <span
            style={{
              height: '12px',
              width: '12px',
              backgroundColor: COLORS.grey600,
              borderRadius: '50%',
              alignSelf: 'center',
              marginRight: '20px',
            }}
          ></span>
          <div style={{ color: COLORS.bluegrey700 }}>Inactive ({inactiveProducts.length})</div>
        </div>
      </>
    )
  }

  render() {
    return <Alert message={this.getMessage()} type='info' />
  }
}
